import { createSlice } from '@reduxjs/toolkit';
import { type RootState } from 'store';
import { type Tablet } from 'types/tablet.types';

export interface ITabletState {
  unassociatedTablets: Tablet[];
  allTablets: Tablet[];
}

const initialState: ITabletState = {
  unassociatedTablets: [],
  allTablets: [],
};

export const tabletSlice = createSlice({
  name: 'tablets',
  initialState,
  reducers: {
    setUnassociatedTabletList(state, { payload }) {
      state.unassociatedTablets = payload;
    },
    setAllTablets(state, { payload }) {
      state.allTablets = payload;
    },
    updateUnassociatedTabletList(state, { payload }) {
      let isTabletInList = false;

      let updated = state.unassociatedTablets.map((tablet) => {
        if (tablet.tabletId === payload.tabletId) {
          isTabletInList = true;
          return payload;
        }
        return tablet;
      });

      // unassociated but not in list yet — add it
      if (!isTabletInList && !payload.assetId) {
        updated.push(payload);
      }

      // now associated — remove from unassociated list
      if (isTabletInList && payload.assetId) {
        updated = updated.filter((t) => t.tabletId !== payload.tabletId);
      }

      state.unassociatedTablets = updated;

      // also sync allTablets
      state.allTablets = state.allTablets.map((t) =>
        t.tabletId === payload.tabletId ? payload : t
      );
    },
  },
});

export const {
  setUnassociatedTabletList,
  setAllTablets,
  updateUnassociatedTabletList,
} = tabletSlice.actions;

export const selectAllTablets = (state: RootState) =>
  state.tabletReducer.allTablets;

export const selectUnassociatedTablets = (state: RootState) =>
  state.tabletReducer.unassociatedTablets;

export default tabletSlice.reducer;
